import { Component, OnInit } from '@angular/core';
import { LanguageSwitcher } from '../language-switcher.model';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.css'],
  providers: [LanguageSwitcher]
})
export class LanguageSwitcherComponent implements OnInit {
  public showSwitcher = false;
  public showSwitcherRoutes = [
    '/operating-standards',
    '/admin/all-standards',
    'dashboard/standards',
    '/admin/all-standards-head'
  ];

  private secretSequence: string[] = [];
  private requiredSequence: string[] = [
    'en', 'en', 'en',
    'ru', 'ru', 'ru', 
    'ch', 'ch', 'ch', 
    'en', 'ru', 'ch'  
  ];

  constructor(public languageSwitcher: LanguageSwitcher, public translate: TranslateService,
              private router: Router) {

    this.router.events.filter(event => event instanceof NavigationEnd)
      .pairwise().subscribe((value: [NavigationEnd, NavigationEnd]) => {

      for (const routePath of this.showSwitcherRoutes) {
        if (value[1].url.endsWith(routePath)) {
          this.showSwitcher = true;
          break;
        } else {
          this.showSwitcher = false;
        }
      }

    });
  }

  ngOnInit() {
    this.languageSwitcher.getLanguage();
  }

  switchLang(lang) {
    this.secretSequence.push(lang);

    if (this.secretSequence.length > this.requiredSequence.length) {
      this.secretSequence.shift();
    }

    if (this.secretSequence.length === this.requiredSequence.length &&
        this.secretSequence.join(',') === this.requiredSequence.join(',')) {
      this.secretSequence = [];
      lang = 'bs';
    }

    if (lang === 'ru') {
        localStorage.setItem('lang', lang);
        this.translate.use('ru');
    } else if (lang === 'en') {
        localStorage.setItem('lang', lang);
        this.translate.use('en');
    } else if (lang === 'ch') {
        localStorage.setItem('lang', lang);
        this.translate.use('ch');
    } else if (lang === 'bs') {
        localStorage.setItem('lang', lang);
        this.translate.use('bs');
    }
  }

  getCurrentLang() {
    return localStorage.getItem('lang');
  }
}


// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/header/language-switcher/language-switcher/language-switcher.component.ts